import { LIST_PAGE_SIZE } from '../utils/index'
export default {
  data() {
    return {
      listData: [],
      listOffset: 0,
      listLimit: LIST_PAGE_SIZE,
      listLoading: false,
      listFinished: false,
      searchPresentId: '',
    }
  },
  methods: {
    resetListState() {
      this.listData = []
      this.listOffset = 0
      this.listFinished = false
      this.listLoading = false
    },
    handleListScroll(event) {
      const el = event.target
      if (this.listLoading || this.listFinished) return
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 80) {
        this.loadListData()
      }
    },
    handleListSearch() {
      this.searchPresentId = (this.searchId || '').trim()
      this.resetListState()
      this.loadListData()
    },
  },
}
